// extracted by css-extract-rspack-plugin
export default {"logoImage":"logoImage-OYLU5c"};